export default "__VITE_ASSET__d1966249__"